require('./orderLinesTable.less');
import {LoDashStatic} from "lodash";

const _ = <LoDashStatic> require('lodash');

class OrderLinesTableController {
    query = {
        page: 1,
        order: ''
    };
    filter = {
        filterText: "",
        active: false
    };
    promise;
    tableDefinition;
    tableContent;
    showConfirmAll;
    universalDate;
    orderNo: number;

    constructor(private toastService, private $state, private OrderLines, private $filter, private Orders, private $mdDialog) {
    }

    $onInit() {
        this.orderNo = this.$state.params.orderNo;
    }

    splitLine(orderLine, event) {
        const vm = this;
        this.$mdDialog.show({
            template: '<rkc-split-line-dialog order-line="c.orderLine" promise="c.promise"></rkc-split-line-dialog>',
            controllerAs: 'c',
            controller: <any>[function () {
                this.orderLine = orderLine;
                this.promise = vm.promise;
            }],
            targetEvent: event,
            clickOutsideToClose: true
        })
            .then(
                (success) => this.getOrderLines(this.orderNo),
                () => {/*cancelled*/
                }
            );
    }

    confirmDate(orderLine) {
        const parsedDate = this.$filter('date')(orderLine.deliveryDate, 'yyyy-MM-dd');
        orderLine.altered = false;
        this.promise = this.OrderLines.setConfirmationDate({
            lineId: orderLine.uniqueId,
            confirmationDate: parsedDate
        }, {}).$promise.then(
            () => this.toastService.showSimpleToast("Bekreftet dato har blitt satt!", 3000),
            (error) => this.toastService.parseError(error)
        );
    }

    confirmOrderDate() {
        const parsedDate = this.$filter('date')(this.universalDate, 'yyyy-MM-dd');
        this.promise = this.Orders.setConfirmationDate({
            orderNumber: this.orderNo,
            confirmationDate: parsedDate
        }, {}).$promise.then(
            (success) => {
                this.showConfirmAll = false;
                this.getOrderLines(this.orderNo);
                this.toastService.showSimpleToast("Bekreftet ordredato har blitt satt!", 3000);
            },
            (error) => this.toastService.parseError(error)
        );

    }

    getOrderLines(orderNo) {
        this.promise = this.Orders.getOrderDetails({orderNumber: orderNo}, {}).$promise.then(
            (results) => {
                this.tableContent = results.orderLines.map(orderLine => {
                    orderLine.deliveryDate = orderLine.deliveryDate ? new Date(orderLine.deliveryDate) : null;
                    return orderLine;
                });
            },
            (error) => this.toastService.parseError(error)
        );
    }

    articleForward(orderLine) {
        if (orderLine.articleNo) {
            this.$state.go('loggedin.articles_articleprofile', {articleNo: orderLine.articleNo});
        }
    }

    isHighlighted(orderLine) {
        return (date) => {
            if (orderLine.routeDays === 0) {
                return true;
            }
            const dayString = (date.getDay() || 7).toString(); // Sets sundays to 7 ( === 0)
            return orderLine.routeDaysString.includes(dayString);
        };
    };

    getSplitTooltip(orderLine) {
        return orderLine.orderType === 'CUSTOMER_ORDER' ? 'Kundeordre kan ikke splittes' :
            orderLine.lockedStructure === "MAIN" ? 'Hovedvarer kan ikke splittes' :
                orderLine.lockedStructure === "SUB" ? 'Undervarer kan ikke splittes' :
                    orderLine.quantity <= 1 ? "Varen må ha antall > 1" :
                        "Splitt Linje";
    }

    getSplitIcon(orderLine) {
        return !orderLine.canSplit || orderLine.quantity < 2 ? 'close' : 'call_split';
    }

    getStructureIcon(orderLine) {
        return orderLine.lockedStructure === 'MAIN' ? 'looks_one' : 'looks_two';
    }

    getStructureTooltip(orderLine) {
        return orderLine.lockedStructure === 'MAIN' ? 'Hovedvare' : 'Undervare';
    }
}

class TableOptions implements ng.IComponentOptions {
    bindings: any = {
        tableContent: '=',
        tableDefinition: '='
    };
    controller: string = 'rkcOrderLinesTableController';
    controllerAs: string = 'c';
    template: any = require('./orderLinesTable.html');
}

rkcApp.controller("rkcOrderLinesTableController", ['toastService', '$state', 'OrderLines', '$filter', 'Orders', '$mdDialog', function (toastService, $state, OrderLines, $filter, Orders, $mdDialog) {
    return new OrderLinesTableController(toastService, $state, OrderLines, $filter, Orders, $mdDialog);
}])
    .component("rkcOrderLinesTable", new TableOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/orderDetails/orderLinesTable/orderLinesTable.ts
 **/